import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http, ApiError } from "@/lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ loading: true, user: null });

  const refresh = useCallback(async () => {
    try {
      let user;
      try {user = await http.get("/auth/me");} catch(e) {if(e.status!==401) throw e; await http.post("/auth/refresh"); user=await http.get("/auth/me");}
      setState({ loading: false, user });
    } catch {
      setState({ loading: false, user: null });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    try {
      const user = await http.post("/auth/login", { email, password });
      setState({ loading: false, user });
      return { ok: true };
    } catch (err) {
      const message = err instanceof ApiError && err.status === 429
        ? "Muitas tentativas. Aguarde alguns minutos."
        : "E-mail ou senha inválidos.";
      return { ok: false, error: message };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await http.post("/auth/logout");
    } finally {
      setState({ loading: false, user: null });
    }
  }, []);

  const hasPermission = useCallback(
    (code) => !!state.user?.permissions?.includes(code),
    [state.user],
  );

  return (
    <AuthContext.Provider value={{ ...state, login, logout, refresh, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
